
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetSalaryEmployeeDetailDto } from '../models/work-budget-salary-employee-detail-dto';

export function getBudgetSalaryDetailsResponseDtoFormGroup() {
return new FormGroup({
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    month: new FormControl<number | undefined>(undefined, [Validators.required]),
    employees: new FormControl<WorkBudgetSalaryEmployeeDetailDto[]>([]),
    totalBase: new FormControl<number | undefined>(undefined, [Validators.required]),
    totalWithMarkup: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      